import type { CreateLicenceCommand, PaginatedListOfLicenceDto, UpdateLicenceCommand } from "../models/models"
import type { HttpResponse } from "../redux/http/http.types"
import type { Licence } from "../redux/licences/licence.types"
import { dispatchSnackbar } from "../services/SnackbarService"
import { hasFailed } from "../utils"
import type { LicenceDto } from "./../models/models"
import { get, post, put, remove } from "./HttpService"

export async function getLicence(id: string): Promise<LicenceDto> {
  const response: HttpResponse<LicenceDto> = await get<LicenceDto>("licence", `licences/${id}`)
  return response.data!
}

export async function getAllLicences(queryString: string): Promise<PaginatedListOfLicenceDto> {
  const response: HttpResponse<PaginatedListOfLicenceDto> = await get<PaginatedListOfLicenceDto>(
    "licence",
    `licences${queryString}`
  )
  return response.data!
}

export async function deleteLicence(id: string): Promise<void> {
  const response: HttpResponse = await remove("licence", `licences/${id}`)
  dispatchSnackbar("licentie", "DELETE", !hasFailed(response))
}

export async function createLicence(licence: Licence): Promise<string> {
  const command: CreateLicenceCommand = {
    name: licence.name,
    ean: licence.ean,
    baseLicenceId: licence.baseLicenceId === "" ? undefined : licence.baseLicenceId
  }
  const response: HttpResponse<string> = await post<string, CreateLicenceCommand>("licence", "licences", command)

  dispatchSnackbar("licentie", "POST", !hasFailed(response))

  return response.data!
}

export async function updateLicence(licence: Licence): Promise<void> {
  const command: UpdateLicenceCommand = {
    id: licence.id as string,
    name: licence.name,
    ean: licence.ean
  }

  const response: HttpResponse = await put<UpdateLicenceCommand>("licence", "licences", command)
  dispatchSnackbar("licentie", "PUT", !hasFailed(response))
}

export async function getUserLicences(): Promise<string[]> {
  const response: HttpResponse<string[]> = await get<string[]>("licence", "licences/user")
  return response.data!
}
